import styled from 'styled-components';

/** Flight row (Figma sAJAbctHkDywtXXMoeVFTZ 8734:944). */
export const FlightStyled = styled.article`
  align-items: flex-start;
  background-color: var(--color-sonata-primary-200);
  border-bottom: 1px solid var(--color-sonata-secondary-white);
  border-top: 1px solid var(--color-sonata-secondary-white);
  column-gap: 14px; /* no token: Figma gap 14 */
  display: flex;
  padding: var(--spacing-16) var(--spacing-24);

  .flight {
    &__color {
      flex: none;
      /* label (18) + gap (8) + half the 40px input minus half the 16px swatch: centred on the inputs */
      margin-top: calc(var(--spacing-32) + var(--spacing-6));
    }

    &__name {
      flex: 1;
      min-width: 0;
    }

    &__date {
      flex: none;
      width: 240px; /* no token: Figma Time window width */
    }

    &__dateError {
      color: var(--color-status-error-550);
      font: var(--font-info-600-regular);
      margin-top: var(--spacing-4);
    }

    &__budget {
      flex: none;
      width: 128px; /* no token: Figma Budget width */
    }

    &__delete {
      margin-top: 26px; /* no token: label (18) + gap (8), aligns the icon with the inputs */
    }
  }
`;
